module.exports = __webpack_public_path__ + "static/media/stephane_roche_profile.54c3cb6d.jpg";